import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import * as crypto from 'crypto';
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { FormEvent } from "react";



export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function capitalizeFirstLetter(string: string | undefined) {
  if(string === '' || string === undefined) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getFirstName(string: string){
  return string.split(' ')[0]
}

export function getLastName(string: string){

  const name = string.split(' ');
  if(name.length === 1) return ''; // if there's only one name return nothing

  return name[name.length-1]; //return the last name 
}

export function getInitials(name: string){

  // if somehow there's a blank name, return n/a
  if(name === ""){
    return "N/a";
  }

  try {
    const splitString = name.split(' ');

    // if the split string only has one section just return that
    if(splitString.length === 1){
      return splitString[0].charAt(0).toUpperCase()
    }
    
    const initialOne = splitString[0].charAt(0)
    const initialTwo = splitString[1].charAt(0)
  
  
    return (initialOne + initialTwo).toUpperCase()
  }
  catch (e){
    console.error(e)
    return '';
  }

 

}

// function for sleeping
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Function to decrypt emails
export function decryptEmail(encryptedEmail: string) {

  try{
    const [ivHex, encrypted] = encryptedEmail.split(':');
    const secretKey = process.env.EMAIL_DECRYPTION_KEY as string;
  
    // Convert the hex string back to a 32-byte buffer
    const secretKeyBuffer = Buffer.from(secretKey, 'hex');
  
    const decipher = crypto.createDecipheriv('aes-256-cbc', secretKeyBuffer, Buffer.from(ivHex, 'hex'));
    let decrypted = decipher.update(encrypted, 'hex', 'utf8');
    decrypted += decipher.final('utf8');
    return decrypted;
  }
  catch (e){
    console.error('The error with decryption is: ', e)
    throw new Error(e);
  }

}

export function getFacebookCookies() {
  const fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))?.split('=')[1] || null;
  const fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='))?.split('=')[1] || null;

  return { fbp, fbc };
}

//function for checking year difference
export function isYearDifference(date1: Date, date2: Date): boolean {
  const millisecondsInOneDay = 1000 * 60 * 60 * 24;
  const differenceInDays = Math.abs(date2.getTime() - date1.getTime()) / millisecondsInOneDay;

  // Check if difference is roughly one year (accounting for leap years)
  return differenceInDays >= 365 && differenceInDays <= 366;
}

export async function addressFromGeocodeID(id: string) {
  try {
      const results = await geocodeByPlaceId(id);
      const address = results[0].formatted_address;
      console.log("Address:", address);
      return address;
  } catch (error) {
      console.error("Error:", error);
      throw error;
  }
}

//this function is for getting the individual day, month and year from a date object
export function getDayMonthYear(date: Date){
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
}

//this function is for getting the date properties from objects within an array
//assumes they'll all be using 'dob' as a property
export function ArrayDatesToDDMMYYYY(data: any[]){
  if(data.length === 0 || !data){
    return [];
  }

  try {
    const transformedData = data.map(child => {
  
      //if there's no dob, return the data with empty strings
      if(!child.dob || child.dob === null){
        return {
          ...child,
          day: "",
          month: "",
          year: "",
          dob: undefined, // Optionally remove dob if you don't want it in the returned object
        };
  
      }
        const dob = new Date(child.dob);
          const day = dob.getUTCDate();
          const month = dob.getUTCMonth() + 1;
          const year = dob.getUTCFullYear();
  
          return {
            ...child,
            day,
            month,
            year,
            dob: undefined, // Optionally remove dob if you don't want it in the returned object
          };
    })
  
    return transformedData;
  }
  catch (e) {
    console.error('The error with transforming the array dates to ddmmyyyy is: ', {e, errormsg: e.message, data})
  }

  return [];
}

export function ObjectDatesToDDMMYYYY(data: {}){
  const dob = new Date(data.dob);
  console.log(dob);

  if(dob === null || !dob || data.dob === null){
    return {
      day: "",
      month: "",
      year: "",
      data,
    };
  }

  try {
    const day = dob.getUTCDate();
    const month = dob.getUTCMonth() + 1;
    const year = dob.getUTCFullYear();
  
    return {
      ...data,
      day,
      month,
      year,
      dob: undefined, // Optionally remove dob if you don't want it in the returned object
    };
  }
  catch (e) {
    console.error('The error with transforming Object dates to DDMMYYYY is: ', {e, data})
  }
}

// Given a single person's data (the nested people object),
// transform its "dob" into day, month, and year.
export function transformDate(data: any) {
  if (!data.dob) return data;
  const dob = new Date(data.dob);
  const day = dob.getUTCDate();
  const month = dob.getUTCMonth() + 1;
  const year = dob.getUTCFullYear();
  return { ...data, day, month, year, dob: undefined };
}

// Flatten an array of objects that each contain a nested "people" property.
// If the array contains exactly one element, return that object.
export function flattenPeopleData(data: any[]) {
  return data.map(item => {
    // Destructure the outer object to separate "people" from the rest.
    const { people, ...rest } = item;
    // If there's a nested "people" object, transform its date.
    const transformedPeople = people ? transformDate(people) : {};
    // Merge the outer properties with the transformed inner object.
    return { ...rest, ...transformedPeople };
  });
}

// stops form propagation for nested forms
// this inner form won't trigger the outer form
export function stopPropagate(callback: (event: FormEvent<HTMLFormElement>) => void) {
  return (e: FormEvent<HTMLFormElement>) => {
    e.stopPropagation();
    callback(e);
  };
}

export const flattenObject = (obj: any) => {
  const flattened = {} as any

  if(obj === null || Object.values(obj).length === 0){
    console.error('Object is empty, returning null: ')
    return null;
  }

  try{
    Object.keys(obj).forEach((key) => {
      const value = obj[key]
  
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        Object.assign(flattened, flattenObject(value))
      } else {
        flattened[key] = value
      }
    })
  }
  catch (e){
    console.error('The error when flattening the object is: ', e)
    return null;
  }

  return flattened
}

// retrieves the first line of an address
export function addressLine1(address: string){
  const newAddress = address.split(',');
  // console.log('THE NEW ADDRESS IS HERE: ', newAddress[0])
  return(newAddress[0]);
}

// geturl is generally just getting the url of the deployment
// oauth param.is for changing how getUrl works depending on whether it's for oauth or not
export function getURL(oauth?: boolean){
    const isProd = process.env.VERCEL_ENV === 'production';

    let url =
    isProd
      ? process.env.VERCEL_PROJECT_PRODUCTION_URL ?? 'https://app.morby.xyz'
      : process.env.PREVIEW_CUSTOM_DOMAIN ?? process.env.VERCEL_URL ?? 'http://localhost:5173';
    // Make sure to include `https://` when not localhost.
    url = url.startsWith('http') ? url : `https://${url}`
    // Make sure to include a trailing `/`.

    // if doing oauth, add auth/callback to url, otherwise just add a forward slash at the end
    url = url.endsWith('/') ? url : oauth ? `${url}/auth/callback` : url += '/'

    console.log('The url is: ', url)
    return url
  }

  export function sanitizeString(filename: string): string {
    return filename
      // Normalize special characters (ä → a, é → e, etc.)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      // Replace remaining non-ASCII characters
      .replace(/[^\x00-\x7F]/g, '_')
      // Replace illegal characters with underscores
      .replace(/[!*'();:@&=+$,/?%#[\]]/g, '_')
      // Replace spaces with underscores
      .replace(/\s+/g, '_')
      // Remove consecutive underscores
      .replace(/_+/g, '_')
      // Trim leading/trailing underscores
      .replace(/^_+|_+$/g, '')
      // Ensure length is within limits
      .substring(0, 255);
}